import { axiosWithSyntaxHandlers as axios } from 'hb-react/shared/utils/axios';
import { type PrivateApiTopic } from 'hb-react/types';

export interface GetGroupsRequestProps {
  params: { fulltext: string; limit: number };
  signal?: AbortSignal;
}

// Function overloads for precise return types
export function getGroupsRequest(props: GetGroupsRequestProps): ReturnType<
  typeof axios.get<{
    data: Array<Pick<PrivateApiTopic, 'id' | 'name'>>;
    total: number;
  }>
>;
export function getGroupsRequest({ params, signal }: GetGroupsRequestProps) {
  const path = Routes.private_backoffice_topics_path();

  return axios.get<{
    data: Array<Pick<PrivateApiTopic, 'id' | 'name'>>;
    total: number;
  }>(path, {
    params,
    signal,
  });
}
